import React from 'react'
import '../../App.css'
import './Testimonial.css'
import '../About/About.css'


import web from '../images/mentor/mentor1.png'
import web2 from '../images/mentor/mentor2.png'
import web3 from '../images/mentor/mentor3.png'
import web4 from '../images/mentor/mentor4.png'
import web5 from '../images/mentor/mentor5.png'
import web6 from '../images/mentor/mentor6.png'
import web7 from '../images/mentor/mentor7.png'
import web8 from '../images/mentor/mentor8.png'
import web9 from '../images/mentor/TseringNawangTamang.png'
import jayant from '../images/mentor/jayant.png'
import web10 from '../images/mentor/nomentor.png'
import sita from '../images/mentor/SitaKC.png'
import raksha from '../images/mentor/RakshaKhadka.png'
import karuna from '../images/mentor/KarunaPandey.png'
import susma from '../images/mentor/SusmaKhatri.png'
export const Testimonial = () => {
    return (
        <section className="testimonial_wrapper">
            <div className="container">
                <h2>Our Testimonial</h2>
                <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    </div>
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="row">
                                <div className="col-md-6 col-sm-12">
                                    <div className="quote">
                                        <p className='quote-text'>Our unique approach combines practical skills required in effective teamwork with innovative thinking as we learn from other successful entrepreneurs throughout the world. We strive toward engaging entrepreneurs by creating collaborative entrepreneurial opportunities which are rooted into real life experiences so they can engage at deeper levels inside their mind.</p>
                                    </div>
                                    <div className="row  m">
                                        <div className="col-md-5 col-sm-12">
                                            <div className="test-img">

                                                <img src={web} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12">
                                            <div className="test-desc">
                                                <h3>Mahendra Gautam</h3>
                                                <span>Serial Entrepreneur</span>
                                                <span>CEO</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <div className="quote">
                                        <p className='quote-text'>Our unique approach combines practical skills required in effective teamwork with innovative thinking as we learn from other successful entrepreneurs throughout the world. We strive toward engaging entrepreneurs by creating collaborative entrepreneurial opportunities which are rooted into real life experiences so they can engage at deeper levels inside their mind.</p>
                                    </div>
                                    <div className="row  m">
                                        <div className="col-md-5 col-sm-12">
                                            <div className="test-img">

                                                <img src={web2} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12">
                                            <div className="test-desc">
                                                <h3>Sudip Acharya</h3>
                                                <span>Serial Entrepreneur</span>
                                                <span>COO</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <div className="row">
                                <div className="col-md-6 col-sm-12">
                                    <div className="quote">
                                        <p className='quote-text'>Our unique approach combines practical skills required in effective teamwork with innovative thinking as we learn from other successful entrepreneurs throughout the world. We strive toward engaging entrepreneurs by creating collaborative entrepreneurial opportunities which are rooted into real life experiences so they can engage at deeper levels inside their mind.</p>
                                    </div>
                                    <div className="row  m">
                                        <div className="col-md-5 col-sm-12">
                                            <div className="test-img">

                                                <img src={web} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12">
                                            <div className="test-desc">
                                                <h3>Mahendra Gautam</h3>
                                                <span>Serial Entrepreneur</span>
                                                <span>CEO</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <div className="quote">
                                        <p className='quote-text'>Our unique approach combines practical skills required in effective teamwork with innovative thinking as we learn from other successful entrepreneurs throughout the world. We strive toward engaging entrepreneurs by creating collaborative entrepreneurial opportunities which are rooted into real life experiences so they can engage at deeper levels inside their mind.</p>
                                    </div>
                                    <div className="row  m">
                                        <div className="col-md-5 col-sm-12">
                                            <div className="test-img">

                                                <img src={web2} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12">
                                            <div className="test-desc">
                                                <h3>Sudip Acharya</h3>
                                                <span>Serial Entrepreneur</span>
                                                <span>COO</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <div className="row">
                                <div className="col-md-6 col-sm-12">
                                    <div className="quote">
                                        <p className='quote-text'>Our unique approach combines practical skills required in effective teamwork with innovative thinking as we learn from other successful entrepreneurs throughout the world. We strive toward engaging entrepreneurs by creating collaborative entrepreneurial opportunities which are rooted into real life experiences so they can engage at deeper levels inside their mind.</p>
                                    </div>
                                    <div className="row  m">
                                        <div className="col-md-5 col-sm-12">
                                            <div className="test-img">

                                                <img src={web} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12">
                                            <div className="test-desc">
                                                <h3>Mahendra Gautam</h3>
                                                <span>Serial Entrepreneur</span>
                                                <span>CEO</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <div className="quote">
                                        <p className='quote-text'>Our unique approach combines practical skills required in effective teamwork with innovative thinking as we learn from other successful entrepreneurs throughout the world. We strive toward engaging entrepreneurs by creating collaborative entrepreneurial opportunities which are rooted into real life experiences so they can engage at deeper levels inside their mind.</p>
                                    </div>
                                    <div className="row  m">
                                        <div className="col-md-5 col-sm-12">
                                            <div className="test-img">

                                                <img src={web2} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12">
                                            <div className="test-desc">
                                                <h3>Sudip Acharya</h3>
                                                <span>Serial Entrepreneur</span>
                                                <span>COO</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>

            <section className="team container">
                        <h2>Our Team</h2>
                        <hr className="thick-border mb-5" />


                        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-indicators">
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                           
                            </div>
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <div className="row mt-3">
                                        <div className="col-sm-3">
                                            <div className="mentor2">
                                                <img src={web} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Mahendra Gautam</h5>
                                                <h6 className='text-center my-2 text-muted'>CEO</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="mentor2">
                                                <img src={web2} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Sudip Acharya</h5>
                                                <h6 className='text-center my-2 text-muted'>COO</h6>
                                            </div>
                                        </div>

                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={jayant} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Jayant Jha </h5>
                                                <h6 className='text-center my-2 text-muted'>CSM</h6>
                                            </div>
                                        </div>

                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web6} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Niman Shakya</h5>
                                                <h6 className='text-center my-2 text-muted'>CDO</h6>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="row mt-3">
                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web5} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Kiran Thapa Magar</h5>
                                                <h6 className='text-center my-2 text-muted'>CMO</h6>
                                            </div>
                                        </div>

                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web10} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Shekher Adhikari</h5>
                                                <h6 className='text-center my-2 text-muted'>CTO</h6>
                                            </div>
                                        </div>

                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web8} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Sukriti Subedi</h5>
                                                <h6 className='text-center my-2 text-muted'>QA Engineer</h6>
                                            </div>
                                        </div>

                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web9} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'> Tsering Nawang Tamang</h5>
                                                <h6 className='text-center my-2 text-muted'>Event Manager</h6>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="row mt-3">


                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web10} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Series Chikanbanjar</h5>
                                                <h6 className='text-center my-2 text-muted'>Tech Lead</h6>
                                            </div>
                                        </div>

                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={sita} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Sita KC</h5>
                                                <h6 className='text-center my-2 text-muted'>Graphic Designer</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web10} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Amrit Gurung</h5>
                                                <h6 className='text-center my-2 text-muted'>Graphic Designer</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web10} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Sikha Neupane</h5>
                                                <h6 className='text-center my-2 text-muted'>Content Writer</h6>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="carousel-item">
                                    <div className="row mt-3">
                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web3} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Gagan Khanal</h5>
                                                <h6 className='text-center my-2 text-muted'>Software Developer</h6>
                                            </div>
                                        </div>
                                        <div className=" col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web4} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Bikesh chaudhari</h5>
                                                <h6 className='text-center my-2 text-muted'>Software Developer</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={raksha} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Raksha Khadka</h5>
                                                <h6 className='text-center my-2 text-muted'>Software Developer</h6>
                                            </div>
                                        </div>


                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web10} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Amit Jung Himali</h5>
                                                <h6 className='text-center my-2 text-muted'>Graphic Designer</h6>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                                <div className="carousel-item">
                                    <div className="row mt-3">


                                        <div className=" col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={karuna} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Karuna Pandey</h5>
                                                <h6 className='text-center my-2 text-muted'>Intern</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={susma} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Sushma Karki</h5>
                                                <h6 className='text-center my-2 text-muted'>Intern</h6>
                                            </div>
                                        </div>

                                        <div className=" col-sm-3 ">
                                            <div className="mentor2">
                                                <img src={web10} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Dristy Aryal</h5>
                                                <h6 className='text-center my-2 text-muted'>Intern</h6>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                              
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>

                    </section>
        </section>
    )
}
